module.exports = "/_next/static/images/icon_bundle_10-dd4bc13e244b249633c9b458fc1badfe.png";